import { type MutableRefObject, useCallback, type RefCallback, type ForwardedRef } from 'react';

export const useCombinedRefs = (
	...refs: (
		| RefCallback<HTMLElement | null>
		| MutableRefObject<HTMLElement | null>
		| ForwardedRef<HTMLElement | null>
	)[]
): RefCallback<HTMLElement | null> => {
	return useCallback(
		(value: HTMLElement | null) => {
			refs.forEach((ref) => {
				if (typeof ref === 'function') {
					ref(value);
				} else if (ref !== null) {
					const localRef = ref;
					localRef.current = value;
				}
			});
		},
		[refs],
	);
};
